'use es6';

import { createActions, createFetchThunk, createReducer } from '../lib/request';
import { getDashboardWidgetCounts } from '../api/dashboard-widget-counts';
import indexBy from 'transmute/indexBy';
import { getId } from 'dashboard-lib/public/dashboard/dashboard-schema';
const base = 'FETCH';
const namespace = 'dashboardWidgetCounts';
export const dashboardWidgetCountsNamespace = namespace;
const actions = createActions(namespace, base);
const fetch = () => getDashboardWidgetCounts().then(indexBy(getId));
export const fetchDashboardWidgetCounts = createFetchThunk(namespace, actions, fetch);
export const reduceDashboardWidgetCount = createReducer(actions);